export const environment = {
    production: true,
    baseUrlBackend: 'https://api.emargis.com',
    baseUrlBackendPrincipal: 'https://api.emargis.com/api',
    webUrl: 'https://emargis.com'
};
  